import { useState, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface TabSpec {
  key: string
  label: ReactNode
  badge?: ReactNode
  content: ReactNode
}

export function Tabs({ tabs, initial, onChange }: { tabs: TabSpec[]; initial?: string; onChange?: (key: string) => void }) {
  const [active, setActive] = useState<string>(initial ?? tabs[0]?.key ?? '')

  function handle(key: string) {
    setActive(key)
    onChange?.(key)
  }

  const activeTab = tabs.find((t) => t.key === active)

  return (
    <div>
      <div className="border-b border-slate-200 dark:border-slate-800">
        <nav className="-mb-px flex flex-wrap gap-x-2" role="tablist" aria-label="Tabok">
          {tabs.map((t) => (
            <button
              key={t.key}
              role="tab"
              aria-selected={active === t.key}
              onClick={() => handle(t.key)}
              className={cn(
                'inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                active === t.key
                  ? 'border-brand-600 text-brand-700 dark:text-brand-300'
                  : 'border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300 dark:text-slate-400 dark:hover:text-slate-100 dark:hover:border-slate-700',
              )}
            >
              {t.label}
              {t.badge}
            </button>
          ))}
        </nav>
      </div>
      <div className="pt-4">{activeTab?.content}</div>
    </div>
  )
}
